export const AUTH_LOCAL_TOKEN_KEY = 'auth_jwt';
export const STREAM_TOKEN_KEY = 'stream_token';
export const AUTH_USER_ID = 'user_id';
export const AUTH_SAVE_PASSWORD = 'auth_save_password';
export const AUTH_AGREEMENT = 'auth_agreement';
export const AUTH_ROLE = 'auth_role';
export const AUTH_URL = 'auth-url';
